import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchIcon, HeartIcon, UserIcon, ShoppingCartIcon, MenuIcon, XIcon } from 'lucide-react';
import { useCart } from '../../context/CartContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const {
    totalItems
  } = useCart();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/50 border-b border-[#1a1a1a]' : 'bg-[#0a0a0a]/80 backdrop-blur-sm'}`} data-id="element-175">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
          <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-177">
            <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 -ml-2 text-gray-400 hover:text-white" aria-label="Відкрити меню" data-id="element-178">
              <MenuIcon className="w-6 h-6" data-id="element-179" />
            </button>

            <Link to="/" className="flex items-center gap-2" data-id="element-180">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center" data-id="element-181">
                <span className="text-white font-bold text-lg" data-id="element-182">A</span>
              </div>
              <span className="text-xl font-bold text-white hidden sm:block" data-id="element-183">
                Aqua Pools
              </span>
            </Link>

            <nav className="hidden lg:flex items-center gap-6" data-id="element-184">
              <Link to="/catalog" className="text-gray-400 hover:text-blue-400 font-medium transition-colors" data-id="element-185">
                Каталог
              </Link>
              <Link to="/contacts" className="text-gray-400 hover:text-blue-400 font-medium transition-colors" data-id="element-186">
                Контакти
              </Link>
            </nav>

            <div className="hidden lg:flex flex-1 max-w-md mx-6" data-id="element-187">
              <div className="relative w-full" data-id="element-188">
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Пошук товарів..." className="w-full pl-10 pr-4 py-2.5 bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl text-sm text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" data-id="element-189" />
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-600" data-id="element-190" />
              </div>
            </div>

            <div className="flex items-center gap-1 sm:gap-3" data-id="element-191">
              <button onClick={() => setIsSearchOpen(true)} className="lg:hidden p-2 text-gray-400 hover:text-white" aria-label="Пошук" data-id="element-192">
                <SearchIcon className="w-6 h-6" data-id="element-193" />
              </button>

              <Link to="/wishlist" className="p-2 text-gray-400 hover:text-white relative" aria-label="Обране" data-id="element-194">
                <HeartIcon className="w-6 h-6" data-id="element-195" />
              </Link>

              <Link to="/account" className="p-2 text-gray-400 hover:text-white" aria-label="Кабінет" data-id="element-196">
                <UserIcon className="w-6 h-6" data-id="element-197" />
              </Link>

              <Link to="/cart" className="flex items-center gap-2 p-2 text-gray-400 hover:text-white relative" aria-label={`Кошик: ${totalItems} товарів`} data-id="element-198">
                <div className="relative" data-id="element-199">
                  <ShoppingCartIcon className="w-6 h-6" data-id="element-200" />
                  {totalItems > 0 && <motion.span initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="absolute -top-2 -right-2 w-5 h-5 bg-blue-600 text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-201">
                      {totalItems}
                    </motion.span>}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-202">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/70 z-50 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-203" />
            <motion.div initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="fixed left-0 top-0 bottom-0 w-full max-w-sm bg-[#0a0a0a] z-50 lg:hidden overflow-y-auto border-r border-[#1a1a1a]" data-id="element-204">
              <div className="sticky top-0 bg-[#0a0a0a] border-b border-[#1a1a1a] p-4 flex items-center justify-between" data-id="element-205">
                <Link to="/" className="flex items-center gap-2" data-id="element-206">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center" data-id="element-207">
                    <span className="text-white font-bold text-lg" data-id="element-208">A</span>
                  </div>
                  <span className="text-xl font-bold text-white" data-id="element-209">
                    Aqua Pools
                  </span>
                </Link>
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 hover:bg-[#1a1a1a] rounded-lg transition-colors" aria-label="Закрити меню" data-id="element-210">
                  <XIcon className="w-6 h-6 text-gray-400" data-id="element-211" />
                </button>
              </div>

              <nav className="p-4" data-id="element-212">
                <div className="space-y-1" data-id="element-213">
                  <Link to="/catalog" className="block px-3 py-2.5 rounded-xl text-gray-300 hover:bg-[#1a1a1a] hover:text-white transition-colors font-medium" data-id="element-214">
                    Каталог
                  </Link>
                  <Link to="/contacts" className="block px-3 py-2.5 rounded-xl text-gray-300 hover:bg-[#1a1a1a] hover:text-white transition-colors font-medium" data-id="element-215">
                    Контакти
                  </Link>
                </div>
              </nav>
            </motion.div>
          </>}
      </AnimatePresence>

      <AnimatePresence data-id="element-216">
        {isSearchOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-[#0a0a0a] z-50 lg:hidden" data-id="element-217">
            <div className="p-4" data-id="element-218">
              <div className="flex items-center gap-3" data-id="element-219">
                <div className="relative flex-1" data-id="element-220">
                  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Пошук товарів..." autoFocus className="w-full pl-10 pr-4 py-3 bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl text-base text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" data-id="element-221" />
                  <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-600" data-id="element-222" />
                </div>
                <button onClick={() => setIsSearchOpen(false)} className="p-2 text-gray-400 hover:text-white" data-id="element-223">
                  Скасувати
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <div className="h-16 lg:h-20" data-id="element-224" />
    </>;
}